import axios from "axios";


const BASE_URL =
    process.env.REACT_APP_API_URL;


// ================= GET AUTH TOKEN =================
const getAuthToken = () => {
    return localStorage.getItem("authToken");
};

// ================= COMMON HEADERS =================
const getHeaders = () => {
    return {
        Accept: "*/*",
        Authorization: `Bearer ${getAuthToken()}`,
        "Content-Type": "application/json",
    };
};

// ================= UPDATE TICKET STATUS =================
export const updateTicketStatusAPI = async (
    ticketId,
    statusToSet,
    responseMessage = ""
) => {
    try {
        if (!ticketId || !statusToSet) {
            throw new Error(
                "Missing ticketId or status"
            );
        }

        let url =
            `${BASE_URL}/promotions/api/user/helpdesk/status/${ticketId}?status=${statusToSet}`;

        if (responseMessage) {
            url +=
                `&responseMessage=${encodeURIComponent(responseMessage)}`;
        }

        console.log(
            "🚀 PUT vendor ticket:",
            url
        );

        const response = await fetch(
            url,
            {
                method: "PUT",
                headers: {
                    Accept: "*/*",
                    Authorization: `Bearer ${getAuthToken()}`,
                },
            }
        );

        const responseText =
            await response.text();

        console.log(
            "📥 Response status:",
            response.status,
            "Body:",
            responseText
        );

        if (!response.ok) {
            throw new Error(
                `Server error ${response.status}: ${responseText}`
            );
        }

        let data = responseText;

        try {
            data = JSON.parse(
                responseText
            );
        } catch (_) { }

        return data;

    } catch (error) {
        console.error(
            "❌ Network error:",
            error
        );

        throw error;
    }
};

// ================= FETCH ALL TICKETS =================
export const getAllVendorTicketsAPI =
    async () => {
        try {
            const response = await fetch(
                `${BASE_URL}/promotions/api/user/helpdesk/all`,
                {
                    headers:
                        getHeaders(),

                    cache:
                        "no-store",
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch vendor tickets(${response.status})`
                );
            }

            const data =
                await response.json();

            console.log(
                "🎫 All Tickets:",
                data
            );

            return data.filter(
                (ticket) =>
                    ticket.createdBy ===
                    "VENDOR" ||
                    ticket.userType ===
                    "VENDOR"
            );

        } catch (error) {
            console.error(
                "❌ Error fetching vendor tickets:",
                error
            );

            throw error;
        }
    };

// ================= GET TICKET DETAILS =================
export const getVendorTicketByIdAPI =
    async (ticketId) => {
        try {
            const response = await fetch(
                `${BASE_URL}/food/api/vendor-tickets/${ticketId}`,
                {
                    headers:
                        getHeaders(),
                }
            );

            if (!response.ok) {
                throw new Error(
                    "Failed to fetch vendor ticket details"
                );
            }

            const data =
                await response.json();

            console.log(
                "🎯 Vendor ticket details:",
                data
            );

            const ticketData =
                Array.isArray(data)
                    ? data[0]
                    : data;

            return {
                ...ticketData,

                id:
                    ticketData.id ||
                    ticketData.ticketId,

                ticketId:
                    ticketData.ticketId ||
                    ticketData.id,

                description:
                    ticketData.description ||
                    ticketData.message ||
                    "No description provided",
            };

        } catch (error) {
            console.error(
                "❌ Error fetching vendor ticket details:",
                error
            );

            throw error;
        }
    };


// ================= GET ALL CUSTOMER TICKETS =================
export const getAllCustomerTicketsAPI =
    async () => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response = await fetch(
                `${BASE_URL}/promotions/api/user/helpdesk/all`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":
                            "application/json",
                    },

                    cache: "no-store",
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch tickets (${response.status})`
                );
            }

            const data =
                await response.json();

            console.log(
                "🎫 All Tickets:",
                data
            );

            return data.filter(
                (ticket) =>
                    ticket.createdBy ===
                    "USER" ||
                    ticket.userType ===
                    "USER"
            );

        } catch (error) {
            console.error(
                "❌ Error fetching customer tickets:",
                error
            );

            throw error;
        }
    };

// ================= UPDATE CUSTOMER TICKET STATUS =================
export const updateCustomerTicketStatusAPI =
    async (
        ticketId,
        statusToSet,
        adminResponseToInclude = null
    ) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (
                !ticketId ||
                !statusToSet
            ) {
                throw new Error(
                    "Missing ticketId or status"
                );
            }

            let url =
                `${BASE_URL}/promotions/api/user/helpdesk/status/${ticketId}?status=${statusToSet}`;

            if (
                adminResponseToInclude
            ) {
                url +=
                    `&adminResponse=${encodeURIComponent(adminResponseToInclude)}`;
            }

            console.log(
                "🚀 PUT:",
                url
            );

            const response =
                await fetch(url, {
                    method: "PUT",

                    headers: {
                        Authorization: `Bearer ${token}`,

                        "Content-Type":
                            "application/json",
                    },
                });

            const responseText =
                await response.text();

            console.log(
                "📥 Response status:",
                response.status,
                "Body:",
                responseText
            );

            if (!response.ok) {
                throw new Error(
                    `Server error ${response.status}: ${responseText}`
                );
            }

            let data =
                responseText;

            try {
                data = JSON.parse(
                    responseText
                );
            } catch (_) { }

            return data;

        } catch (error) {
            console.error(
                "❌ Network error:",
                error
            );

            throw error;
        }
    };

// ================= GET CUSTOMER TICKET DETAILS =================
export const getCustomerTicketByIdAPI =
    async (ticketId) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response = await fetch(
                `${BASE_URL}/promotions/api/user/helpdesk/${ticketId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,

                        "Content-Type":
                            "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(
                    "Failed to fetch ticket details"
                );
            }

            const data =
                await response.json();

            console.log(
                "🎯 Ticket details:",
                data
            );

            return {
                ...data,

                id:
                    data.id ||
                    data.ticketId,

                ticketId:
                    data.ticketId ||
                    data.id,

                description:
                    data.description ||
                    data.message ||
                    "No description provided",
            };

        } catch (error) {
            console.error(
                "❌ Error fetching ticket details:",
                error
            );

            throw error;
        }
    };
export const getAllTickets = async (token) => {
    const response = await axios.get(
        `${BASE_URL}/all`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            withCredentials: true,
        }
    );

    return response.data;
};

// =====================
// GET ANALYTICS
// =====================
export const getAnalytics = async (token) => {
    const response = await axios.get(
        `${BASE_URL}/analytics`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            withCredentials: true,
        }
    );

    return response.data;
};

// =====================
// UPDATE TICKET STATUS
// =====================
export const updateTicket = async (
    ticketId,
    status,
    adminResponse,
    token
) => {
    const response = await axios.put(
        `${BASE_URL}/status/${ticketId}`,
        null,
        {
            params: {
                status: status.toUpperCase(),
                adminResponse: adminResponse || "",
            },
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            withCredentials: true,
        }
    );

    return response.data;
};